/* specifically target IE11 */
/* controlled focus outline */
@import url("https://fonts.googleapis.com/css?family=Open+Sans:100,200,300,400,500,600,700,800|Titillium+Web:100,200,300,400,500,600,700,800");
/**
 * AGL BRAND TOKENS VERSION 0.2.45
 * GENERATED BY STYLE DICTIONARY
 * DO NOT EDIT THIS FILE DIRECTLY
 */
/* usage
.selector {
  color: red;

  @include breakpoint(sm) {
    color: blue;
  }
}
*/
/**
 * AGL BRAND TOKENS VERSION 0.2.45
 * GENERATED BY STYLE DICTIONARY
 * DO NOT EDIT THIS FILE DIRECTLY
 */
/**
 * AGL DARK TOKENS VERSION 0.2.45
 * GENERATED BY STYLE DICTIONARY
 * DO NOT EDIT THIS FILE DIRECTLY
 */
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
  ========================================================================== */
/**
* 1. Correct the line height in all browsers.
* 2. Prevent adjustments of font size after orientation changes in iOS.
*/
html {
  line-height: 1;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
  ========================================================================== */
/**
* Render the `main` element consistently in IE.
*/
main {
  display: block;
}

/* Grouping content
  ========================================================================== */
/**
* 1. Add the correct box sizing in Firefox.
* 2. Show the overflow in Edge and IE.
*/
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
* 1. Correct the inheritance and scaling of font size in all browsers.
* 2. Correct the odd `em` font sizing in all browsers.
*/
pre {
  font-family: monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
  ========================================================================== */
/**
* 1. Remove the bottom border in Chrome 57-
* 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
*/
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
* Add the correct font weight in Chrome, Edge, and Safari.
*/
b,
strong {
  font-weight: 700;
}

/**
* 1. Correct the inheritance and scaling of font size in all browsers.
* 2. Correct the odd `em` font sizing in all browsers.
*/
code,
kbd,
samp {
  font-family: monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
* Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/**
* Prevent `sub` and `sup` elements from affecting the line height in
* all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Forms
  ========================================================================== */
/**
* 1. Change the font styles in all browsers.
* 2. Remove the margin in Firefox and Safari.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
* Show the overflow in IE.
* 1. Show the overflow in Edge.
*/
button,
input {
  /* 1 */
  overflow: visible;
}

/**
* Remove the inheritance of text transform in Edge, Firefox, and IE.
* 1. Remove the inheritance of text transform in Firefox.
*/
button,
select {
  /* 1 */
  text-transform: none;
}

/**
* Correct the inability to style clickable types in iOS and Safari.
*/
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
* 1. Correct the text wrapping in Edge and IE.
* 2. Correct the color inheritance from `fieldset` elements in IE.
*/
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  white-space: normal;
  /* 1 */
}

/**
* Add the correct vertical alignment in Chrome, Firefox, and Opera.
*/
progress {
  vertical-align: baseline;
}

/**
* Remove the default vertical scrollbar in IE 10+.
*/
textarea {
  overflow: auto;
}

/* Interactive
  ========================================================================== */
/*
* Add the correct display in Edge, IE 10+, and Firefox.
*/
details {
  display: block;
}

/*
* Add the correct display in all browsers.
*/
summary {
  display: list-item;
}

/* Misc
  ========================================================================== */
/**
* Add the correct display in IE 10+.
*/
template {
  display: none;
}

/* HTML5 display-role reset for older browsers */
details,
footer,
header,
menu,
nav,
section {
  display: block;
}

html,
body,
div,
span,
h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
img,
u,
i,
center,
ol,
ul,
li,
fieldset,
form,
label,
legend,
footer,
header,
menu,
nav,
section,
summary,
button {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  line-height: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
}
html:focus,
body:focus,
div:focus,
span:focus,
h1:focus,
h2:focus,
h3:focus,
h4:focus,
h5:focus,
h6:focus,
p:focus,
a:focus,
img:focus,
u:focus,
i:focus,
center:focus,
ol:focus,
ul:focus,
li:focus,
fieldset:focus,
form:focus,
label:focus,
legend:focus,
footer:focus,
header:focus,
menu:focus,
nav:focus,
section:focus,
summary:focus,
button:focus {
  outline: none;
}

body {
  --colors-primary-01: #001cb0;
  --colors-primary-02: #00dfed;
  --colors-secondary-01: #ffe344;
  --colors-secondary-02: #f6a623;
  --colors-secondary-03: #9d15ff;
  --colors-secondary-04: #6031a6;
  --colors-tertiary-01: #38e255;
  --colors-tertiary-02: #00c981;
  --colors-tertiary-03: #f80ec5;
  --colors-tertiary-04: #ff5454;
  --colors-tint-tertiary-03-10: #fee7f9;
  --colors-tint-tertiary-03-20: #fecff3;
  --colors-tint-tertiary-03-30: #fdb7ee;
  --colors-tint-tertiary-03-40: #fc9fe8;
  --colors-tint-tertiary-03-50: #fc87e2;
  --colors-tint-tertiary-03-60: #fb6edc;
  --colors-tint-tertiary-03-70: #fa56d6;
  --colors-tint-tertiary-03-80: #f93ed1;
  --colors-tint-tertiary-03-90: #f926cb;
  --colors-tint-tertiary-04-10: #ffebed;
  --colors-tint-tertiary-04-20: #ffd6db;
  --colors-tint-tertiary-04-30: #fec2c9;
  --colors-tint-tertiary-04-40: #feadb7;
  --colors-tint-tertiary-04-50: #fe99a6;
  --colors-tint-tertiary-04-60: #fe8594;
  --colors-tint-tertiary-04-70: #fe7082;
  --colors-tint-tertiary-04-80: #fd5c70;
  --colors-tint-tertiary-04-90: #fd475e;
  --colors-tint-tertiary-01-10: #edfbf0;
  --colors-tint-tertiary-01-20: #dbf7e0;
  --colors-tint-tertiary-01-30: #c9f4d1;
  --colors-tint-tertiary-01-40: #b7f0c1;
  --colors-tint-tertiary-01-50: #a6ecb2;
  --colors-tint-tertiary-01-60: #94e8a2;
  --colors-tint-tertiary-01-70: #82e493;
  --colors-tint-tertiary-01-80: #70e183;
  --colors-tint-tertiary-01-90: #5edd74;
  --colors-tint-tertiary-02-10: #eaf7e8;
  --colors-tint-tertiary-02-20: #d5eed1;
  --colors-tint-tertiary-02-30: #c0e6ba;
  --colors-tint-tertiary-02-40: #abdda3;
  --colors-tint-tertiary-02-50: #96d58c;
  --colors-tint-tertiary-02-60: #80cc74;
  --colors-tint-tertiary-02-70: #6bc45d;
  --colors-tint-tertiary-02-80: #56bb46;
  --colors-tint-tertiary-02-90: #41b32f;
  --colors-tint-secondary-02-10: #fef6e9;
  --colors-tint-secondary-02-20: #fdedd3;
  --colors-tint-secondary-02-30: #fce4bd;
  --colors-tint-secondary-02-40: #fbdba7;
  --colors-tint-secondary-02-50: #fbd391;
  --colors-tint-secondary-02-60: #faca7b;
  --colors-tint-secondary-02-70: #f9c165;
  --colors-tint-secondary-02-80: #f8b84f;
  --colors-tint-secondary-02-90: #f7af39;
  --colors-tint-secondary-04-10: #efeaf6;
  --colors-tint-secondary-04-20: #dfd6ed;
  --colors-tint-secondary-04-30: #cfc1e4;
  --colors-tint-secondary-04-40: #bfaddb;
  --colors-tint-secondary-04-50: #b098d3;
  --colors-tint-secondary-04-60: #a083ca;
  --colors-tint-secondary-04-70: #906fc1;
  --colors-tint-secondary-04-80: #805ab8;
  --colors-tint-secondary-04-90: #7046af;
  --colors-tint-secondary-01-10: #fffcec;
  --colors-tint-secondary-01-20: #fff9da;
  --colors-tint-secondary-01-30: #fff7c7;
  --colors-tint-secondary-01-40: #fff4b4;
  --colors-tint-secondary-01-50: #fff1a2;
  --colors-tint-secondary-01-60: #ffee8f;
  --colors-tint-secondary-01-70: #ffeb7c;
  --colors-tint-secondary-01-80: #ffe969;
  --colors-tint-secondary-01-90: #ffe657;
  --colors-tint-secondary-03-10: #f5e8ff;
  --colors-tint-secondary-03-20: #ebd0ff;
  --colors-tint-secondary-03-30: #e2b9ff;
  --colors-tint-secondary-03-40: #d8a1ff;
  --colors-tint-secondary-03-50: #ce8aff;
  --colors-tint-secondary-03-60: #c473ff;
  --colors-tint-secondary-03-70: #ba5bff;
  --colors-tint-secondary-03-80: #b144ff;
  --colors-tint-secondary-03-90: #a72cff;
  --colors-tint-primary-02-10: #e6fcfd;
  --colors-tint-primary-02-20: #ccf9fb;
  --colors-tint-primary-02-30: #b3f5fa;
  --colors-tint-primary-02-40: #99f2f8;
  --colors-tint-primary-02-50: #80eff6;
  --colors-tint-primary-02-60: #66ecf4;
  --colors-tint-primary-02-70: #4de9f2;
  --colors-tint-primary-02-80: #33e5f1;
  --colors-tint-primary-02-90: #1ae2ef;
  --colors-tint-primary-01-10: #e6e8f7;
  --colors-tint-primary-01-20: #ccd2ef;
  --colors-tint-primary-01-30: #b3bbe7;
  --colors-tint-primary-01-40: #99a4df;
  --colors-tint-primary-01-50: #808ed8;
  --colors-tint-primary-01-60: #6677d0;
  --colors-tint-primary-01-70: #4d60c8;
  --colors-tint-primary-01-80: #3349c0;
  --colors-tint-primary-01-90: #1a33b8;
  --colors-tint-primary-01-110: #00168d;
  --colors-neutral-00: #000000;
  --colors-neutral-01: #2b2e31;
  --colors-neutral-02: #6b6d77;
  --colors-neutral-03: #a7a9b3;
  --colors-neutral-04: #c8cbd7;
  --colors-neutral-05: #d6d9e0;
  --colors-neutral-06: #eff0f4;
  --colors-neutral-07: #f7f7f9;
  --colors-neutral-08: #ffffff;
  --colors-static-neutral-00: #000000;
  --colors-static-neutral-01: #2b2e31;
  --colors-static-neutral-02: #6b6d77;
  --colors-static-neutral-03: #a7a9b3;
  --colors-static-neutral-04: #c8cbd7;
  --colors-static-neutral-05: #d6d9e0;
  --colors-static-neutral-06: #eff0f4;
  --colors-static-neutral-07: #f7f7f9;
  --colors-static-neutral-08: #ffffff;
  --colors-gradient-base-01: #0075cc;
  --colors-gradient-base-02: #b51db7;
  --colors-gradient-base-03: #9d15ff;
  --colors-gradient-base-04: #670bdf;
  --colors-alert-success: #008000;
  --colors-alert-error: #ce2a3e;
  --colors-alert-warning: #f6a623;
  --colors-alert-information: #6031a6;
  --colors-alert-null: #a7a9b3;
  --colors-elevation-opacity01: rgba(0, 0, 0, 0.08);
  --colors-elevation-opacity02: rgba(0, 0, 0, 0.16);
  --colors-gradient-01: #000000;
  --colors-gradient-02: #000000;
  --colors-gradient-03: #000000;
  --colors-gradient-04: #000000;
  --colors-gradient-05: #000000;
  --colors-gradient-06: #000000;
  --colors-mobile-01: #007aff;
  --colors-bridging-interactive-01: #001cb0;
  --colors-bridging-interactive-02: #00dfed;
  --colors-bridging-interactive-03: #6031a6;
  --colors-bridging-interactive-link-01: #001cb0;
  --colors-bridging-interactive-link-02: #3349c0;
  --colors-bridging-interactive-link-03: #6031a6;
  --colors-bridging-interactive-pressed-01: #00168d;
  --colors-bridging-interactive-pressed-02: #b3bbe7;
  --colors-bridging-interactive-pressed-03: #4d60c8;
  --colors-bridging-interactive-hover-01: #3349c0;
  --colors-bridging-interactive-hover-02: #ccd2ef;
  --colors-bridging-interactive-inverse-01: #ffffff;
  --colors-bridging-interactive-inverse-02: #00dfed;
  --colors-bridging-interactive-inverse-03: #6031a6;
  --colors-bridging-interactive-inverse-link-01: #ffffff;
  --colors-bridging-interactive-inverse-link-02: #ccd2ef;
  --colors-bridging-interactive-inverse-link-03: #b3bbe7;
  --colors-bridging-interactive-inverse-pressed-01: #b3bbe7;
  --colors-bridging-interactive-inverse-pressed-02: #4d60c8;
  --colors-bridging-interactive-inverse-hover-01: #ccd2ef;
  --colors-bridging-interactive-disabled-01: #c8cbd7;
  --colors-bridging-interactive-disabled-02: #6b6d77;
  --colors-bridging-interactive-disabled-03: #a7a9b3;
  --colors-bridging-interactive-focus-01: #fc9fe8;
  --colors-bridging-border-01: #2b2e31;
  --colors-bridging-border-02: #6b6d77;
  --colors-bridging-border-03: #d6d9e0;
  --colors-bridging-border-04: #001cb0;
  --colors-bridging-border-05: #ffffff;
  --colors-bridging-icon-01: #2b2e31;
  --colors-bridging-icon-02: #6b6d77;
  --colors-bridging-icon-03: #a7a9b3;
  --colors-bridging-icon-04: #001cb0;
  --colors-bridging-icon-05: #ffffff;
  --colors-bridging-icon-highlight-01: #001cb0;
  --colors-bridging-icon-highlight-02: #6031a6;
  --colors-bridging-icon-pressed-01: #ccd2ef;
  --colors-bridging-icon-pressed-02: #3349c0;
  --colors-bridging-icon-hover-01: #ffffff;
  --colors-bridging-icon-hover-02: #001cb0;
  --colors-bridging-icon-inverse-pressed-01: #3349c0;
  --colors-bridging-icon-inverse-pressed-02: #ccd2ef;
  --colors-bridging-icon-inverse-hover-01: #001cb0;
  --colors-bridging-focus-01: #fc9fe8;
  --colors-bridging-focus-02: #007aff;
  --colors-bridging-focus-03: #000000;
  --colors-bridging-type-01: #2b2e31;
  --colors-bridging-type-02: #6b6d77;
  --colors-bridging-type-03: #a7a9b3;
  --colors-bridging-type-04: #001cb0;
  --colors-bridging-type-05: #ffffff;
  --colors-bridging-type-highlight-01: #001cb0;
  --colors-bridging-type-highlight-02: #6031a6;
  --colors-bridging-type-pressed-01: #ccd2ef;
  --colors-bridging-type-pressed-02: #3349c0;
  --colors-bridging-type-hover-01: #ffffff;
  --colors-bridging-type-hover-02: #001cb0;
  --colors-bridging-type-inverse-pressed-01: #3349c0;
  --colors-bridging-type-inverse-pressed-02: #ccd2ef;
  --colors-bridging-type-inverse-hover-01: #001cb0;
  --colors-bridging-background-ui-01: #ffffff;
  --colors-bridging-background-ui-04: #2b2e31;
  --colors-bridging-background-level-01: #ffffff;
  --colors-bridging-background-level-02: #ffffff;
  --colors-bridging-background-level-03: #ffffff;
  --colors-bridging-background-level-04: #ffffff;
  --colors-bridging-background-level-05: #ffffff;
  --colors-bridging-background-level-gradient01: #000000;
  --colors-bridging-background-modal: #2b2e31;
  --colors-component-primary-01: #001cb0;
  --colors-component-primary-02: #00dfed;
  --colors-component-secondary-01: #ffe344;
  --colors-component-secondary-02: #f6a623;
  --colors-component-secondary-03: #9d15ff;
  --colors-component-secondary-04: #6031a6;
  --colors-component-tertiary-01: #38e255;
  --colors-component-tertiary-02: #00c981;
  --colors-component-tertiary-03: #f80ec5;
  --colors-component-tertiary-04: #ff5454;
  --colors-component-tint-primary-01-60: #6677d0;
  --colors-component-tint-primary-01-80: #3349c0;
  --colors-component-tint-primary-02-60: #66ecf4;
  --colors-component-tint-primary-02-80: #33e5f1;
  --colors-component-tint-secondary-01-60: #ffee8f;
  --colors-component-tint-secondary-01-80: #ffe969;
  --colors-component-tint-secondary-02-60: #faca7b;
  --colors-component-tint-secondary-02-80: #f8b84f;
  --colors-component-tint-secondary-03-60: #c473ff;
  --colors-component-tint-secondary-03-80: #b144ff;
  --colors-component-tint-secondary-04-60: #a083ca;
  --colors-component-tint-secondary-04-80: #805ab8;
  --colors-component-tint-tertiary-01-60: #94e8a2;
  --colors-component-tint-tertiary-01-80: #70e183;
  --colors-component-tint-tertiary-02-60: #80cc74;
  --colors-component-tint-tertiary-02-80: #56bb46;
  --colors-component-tint-tertiary-03-60: #fb6edc;
  --colors-component-tint-tertiary-03-80: #f93ed1;
  --colors-component-tint-tertiary-04-60: #fe8594;
  --colors-component-tint-tertiary-04-80: #fd5c70;
  --colors-component-button-default-background-primary-enabled: #001cb0;
  --colors-component-button-default-background-primary-hover: #3349c0;
  --colors-component-button-default-background-primary-pressed: #00168d;
  --colors-component-button-default-background-secondary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-default-background-secondary-hover: #ccd2ef;
  --colors-component-button-default-background-secondary-pressed: #b3bbe7;
  --colors-component-button-default-background-tertiary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-default-background-tertiary-hover: #ccd2ef;
  --colors-component-button-default-background-tertiary-pressed: #b3bbe7;
  --colors-component-button-default-background-disabled: #c8cbd7;
  --colors-component-button-default-type-primary-enabled: #ffffff;
  --colors-component-button-default-type-primary-hover: #ffffff;
  --colors-component-button-default-type-primary-pressed: #ccd2ef;
  --colors-component-button-default-type-secondary-enabled: #001cb0;
  --colors-component-button-default-type-secondary-hover: #001cb0;
  --colors-component-button-default-type-secondary-pressed: #3349c0;
  --colors-component-button-default-type-tertiary-enabled: #001cb0;
  --colors-component-button-default-type-tertiary-hover: #001cb0;
  --colors-component-button-default-type-tertiary-pressed: #3349c0;
  --colors-component-button-default-type-disabled: #6b6d77;
  --colors-component-button-default-icon-primary-enabled: #ffffff;
  --colors-component-button-default-icon-primary-hover: #ffffff;
  --colors-component-button-default-icon-primary-pressed: #ccd2ef;
  --colors-component-button-default-icon-secondary-enabled: #001cb0;
  --colors-component-button-default-icon-secondary-hover: #001cb0;
  --colors-component-button-default-icon-secondary-pressed: #3349c0;
  --colors-component-button-default-icon-tertiary-enabled: #001cb0;
  --colors-component-button-default-icon-tertiary-hover: #001cb0;
  --colors-component-button-default-icon-tertiary-pressed: #3349c0;
  --colors-component-button-default-icon-disabled: #6b6d77;
  --colors-component-button-default-border-secondary-enabled: #001cb0;
  --colors-component-button-inverse-background-primary-enabled: #ffffff;
  --colors-component-button-inverse-background-primary-hover: #ccd2ef;
  --colors-component-button-inverse-background-primary-pressed: #4d60c8;
  --colors-component-button-inverse-background-secondary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-inverse-background-secondary-hover: #ccd2ef;
  --colors-component-button-inverse-background-secondary-pressed: #4d60c8;
  --colors-component-button-inverse-background-tertiary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-inverse-background-tertiary-hover: #ccd2ef;
  --colors-component-button-inverse-background-tertiary-pressed: #4d60c8;
  --colors-component-button-inverse-background-disabled: #c8cbd7;
  --colors-component-button-inverse-type-primary-enabled: #001cb0;
  --colors-component-button-inverse-type-primary-hover: #001cb0;
  --colors-component-button-inverse-type-primary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-secondary-enabled: #ffffff;
  --colors-component-button-inverse-type-secondary-hover: #001cb0;
  --colors-component-button-inverse-type-secondary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-tertiary-enabled: #ffffff;
  --colors-component-button-inverse-type-tertiary-hover: #001cb0;
  --colors-component-button-inverse-type-tertiary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-disabled: #6b6d77;
  --colors-component-button-inverse-icon-primary-enabled: #001cb0;
  --colors-component-button-inverse-icon-primary-hover: #001cb0;
  --colors-component-button-inverse-icon-primary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-secondary-enabled: #ffffff;
  --colors-component-button-inverse-icon-secondary-hover: #001cb0;
  --colors-component-button-inverse-icon-secondary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-tertiary-enabled: #ffffff;
  --colors-component-button-inverse-icon-tertiary-hover: #001cb0;
  --colors-component-button-inverse-icon-tertiary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-disabled: #6b6d77;
  --colors-component-button-inverse-border-secondary-enabled: #ffffff;
  --colors-component-radio-border-enabled: #6b6d77;
  --colors-component-radio-border-hover: #2b2e31;
  --colors-component-radio-border-pressed: #00168d;
  --colors-component-radio-border-error: #ce2a3e;
  --colors-component-radio-border-selected-enabled: #001cb0;
  --colors-component-radio-border-selected-hover: #3349c0;
  --colors-component-radio-border-selected-error: #ce2a3e;
  --colors-component-radio-type-enabled: #2b2e31;
  --colors-component-radio-type-disabled: #6b6d77;
  --colors-component-radio-background: #ffffff;
  --colors-component-checkbox-border-enabled: #6b6d77;
  --colors-component-checkbox-border-hover: #2b2e31;
  --colors-component-checkbox-border-pressed: #00168d;
  --colors-component-checkbox-border-error: #ce2a3e;
  --colors-component-checkbox-background-unselected: #ffffff;
  --colors-component-checkbox-background-selected: #001cb0;
  --colors-component-checkbox-background-hover: #3349c0;
  --colors-component-checkbox-background-pressed: #00168d;
  --colors-component-checkbox-background-error: #ce2a3e;
  --colors-component-checkbox-icon: #ffffff;
  --colors-component-focus: #fc9fe8;
  --colors-component-text-input-background: #ffffff;
  --colors-component-text-input-border-enabled: #6b6d77;
  --colors-component-text-input-border-hover: #2b2e31;
  --colors-component-text-input-border-active: #001cb0;
  --colors-component-text-input-border-error: #ce2a3e;
  --colors-component-dropdown-background: #ffffff;
  --colors-component-dropdown-border-enabled: #6b6d77;
  --colors-component-dropdown-border-hover: #2b2e31;
  --colors-component-dropdown-border-active: #001cb0;
  --colors-component-dropdown-border-error: #ce2a3e;
  --colors-component-form-type-label: #2b2e31;
  --colors-component-form-type-hint: #6b6d77;
  --colors-component-form-type-input: #2b2e31;
  --colors-component-form-type-validation-error: #ce2a3e;
  --colors-component-form-type-validation-success: #2b2e31;
  --colors-component-form-type-validation-information: #2b2e31;
  --colors-component-form-icon-validation-error: #ce2a3e;
  --colors-component-form-icon-validation-success: #008000;
  --colors-component-form-icon-validation-information: #6031a6;
  --colors-component-form-modal-type-header: #2b2e31;
  --colors-component-form-modal-type-copy: #2b2e31;
  --colors-component-form-modal-background-enabled: #ffffff;
  --colors-component-link-default-enabled: #001cb0;
  --colors-component-link-default-hover: #3349c0;
  --colors-component-link-default-visited: #6031a6;
  --colors-component-link-inverse-enabled: #ffffff;
  --colors-component-link-inverse-hover: #ccd2ef;
  --colors-component-link-inverse-visited: #b3bbe7;
  --colors-component-card-interactive-border-enabled: #d6d9e0;
  --colors-component-card-interactive-border-hover: #d6d9e0;
  --colors-component-card-interactive-border-pressed: #00168d;
  --colors-component-card-interactive-border-selected: #001cb0;
  --colors-component-card-interactive-border-error: #ce2a3e;
  --colors-component-card-interactive-background-enabled: #ffffff;
  --colors-component-card-interactive-background-hover: #ffffff;
  --colors-component-card-interactive-background-pressed: #ffffff;
  --colors-component-card-interactive-background-selected: #ffffff;
  --colors-component-card-interactive-background-error: #ffffff;
  --colors-component-card-static-border: #d6d9e0;
  --colors-component-card-static-background-level0: #ffffff;
  --colors-component-card-static-background-level1: #ffffff;
  --colors-component-card-static-background-level5: #ffffff;
  --colors-component-card-type-header: #2b2e31;
  --colors-component-card-type-body: #2b2e31;
  --colors-component-notification-strip-background-promo: #6031a6;
  --colors-component-notification-strip-background-warning: #f6a623;
  --colors-component-notification-strip-background-information: #6031a6;
  --colors-component-notification-strip-background-error: #ce2a3e;
  --colors-component-notification-strip-background-success: #008000;
  --colors-component-notification-icon-warning: #f6a623;
  --colors-component-notification-icon-information: #6031a6;
  --colors-component-notification-icon-error: #ce2a3e;
  --colors-component-notification-icon-success: #008000;
  --colors-component-notification-icon-disabled: #a7a9b3;
  --colors-component-typography-enabled: #2b2e31;
  --colors-component-typography-muted: #6b6d77;
  --colors-component-typography-highlight: #001cb0;
  --colors-component-typography-error: #ce2a3e;
  --colors-component-typography-inverse-enabled: #ffffff;
  --colors-component-typography-secondary-highlight: #6031a6;
  --colors-component-scrim: #2b2e31;
  --colors-component-modal-static-dividing-line: #d6d9e0;
}

.colour-mode--light,
dls-theme-agl[mode=light] {
  --colors-primary-01: #001cb0;
  --colors-primary-02: #00dfed;
  --colors-secondary-01: #ffe344;
  --colors-secondary-02: #f6a623;
  --colors-secondary-03: #9d15ff;
  --colors-secondary-04: #6031a6;
  --colors-tertiary-01: #38e255;
  --colors-tertiary-02: #00c981;
  --colors-tertiary-03: #f80ec5;
  --colors-tertiary-04: #ff5454;
  --colors-tint-tertiary-03-10: #fee7f9;
  --colors-tint-tertiary-03-20: #fecff3;
  --colors-tint-tertiary-03-30: #fdb7ee;
  --colors-tint-tertiary-03-40: #fc9fe8;
  --colors-tint-tertiary-03-50: #fc87e2;
  --colors-tint-tertiary-03-60: #fb6edc;
  --colors-tint-tertiary-03-70: #fa56d6;
  --colors-tint-tertiary-03-80: #f93ed1;
  --colors-tint-tertiary-03-90: #f926cb;
  --colors-tint-tertiary-04-10: #ffebed;
  --colors-tint-tertiary-04-20: #ffd6db;
  --colors-tint-tertiary-04-30: #fec2c9;
  --colors-tint-tertiary-04-40: #feadb7;
  --colors-tint-tertiary-04-50: #fe99a6;
  --colors-tint-tertiary-04-60: #fe8594;
  --colors-tint-tertiary-04-70: #fe7082;
  --colors-tint-tertiary-04-80: #fd5c70;
  --colors-tint-tertiary-04-90: #fd475e;
  --colors-tint-tertiary-01-10: #edfbf0;
  --colors-tint-tertiary-01-20: #dbf7e0;
  --colors-tint-tertiary-01-30: #c9f4d1;
  --colors-tint-tertiary-01-40: #b7f0c1;
  --colors-tint-tertiary-01-50: #a6ecb2;
  --colors-tint-tertiary-01-60: #94e8a2;
  --colors-tint-tertiary-01-70: #82e493;
  --colors-tint-tertiary-01-80: #70e183;
  --colors-tint-tertiary-01-90: #5edd74;
  --colors-tint-tertiary-02-10: #eaf7e8;
  --colors-tint-tertiary-02-20: #d5eed1;
  --colors-tint-tertiary-02-30: #c0e6ba;
  --colors-tint-tertiary-02-40: #abdda3;
  --colors-tint-tertiary-02-50: #96d58c;
  --colors-tint-tertiary-02-60: #80cc74;
  --colors-tint-tertiary-02-70: #6bc45d;
  --colors-tint-tertiary-02-80: #56bb46;
  --colors-tint-tertiary-02-90: #41b32f;
  --colors-tint-secondary-02-10: #fef6e9;
  --colors-tint-secondary-02-20: #fdedd3;
  --colors-tint-secondary-02-30: #fce4bd;
  --colors-tint-secondary-02-40: #fbdba7;
  --colors-tint-secondary-02-50: #fbd391;
  --colors-tint-secondary-02-60: #faca7b;
  --colors-tint-secondary-02-70: #f9c165;
  --colors-tint-secondary-02-80: #f8b84f;
  --colors-tint-secondary-02-90: #f7af39;
  --colors-tint-secondary-04-10: #efeaf6;
  --colors-tint-secondary-04-20: #dfd6ed;
  --colors-tint-secondary-04-30: #cfc1e4;
  --colors-tint-secondary-04-40: #bfaddb;
  --colors-tint-secondary-04-50: #b098d3;
  --colors-tint-secondary-04-60: #a083ca;
  --colors-tint-secondary-04-70: #906fc1;
  --colors-tint-secondary-04-80: #805ab8;
  --colors-tint-secondary-04-90: #7046af;
  --colors-tint-secondary-01-10: #fffcec;
  --colors-tint-secondary-01-20: #fff9da;
  --colors-tint-secondary-01-30: #fff7c7;
  --colors-tint-secondary-01-40: #fff4b4;
  --colors-tint-secondary-01-50: #fff1a2;
  --colors-tint-secondary-01-60: #ffee8f;
  --colors-tint-secondary-01-70: #ffeb7c;
  --colors-tint-secondary-01-80: #ffe969;
  --colors-tint-secondary-01-90: #ffe657;
  --colors-tint-secondary-03-10: #f5e8ff;
  --colors-tint-secondary-03-20: #ebd0ff;
  --colors-tint-secondary-03-30: #e2b9ff;
  --colors-tint-secondary-03-40: #d8a1ff;
  --colors-tint-secondary-03-50: #ce8aff;
  --colors-tint-secondary-03-60: #c473ff;
  --colors-tint-secondary-03-70: #ba5bff;
  --colors-tint-secondary-03-80: #b144ff;
  --colors-tint-secondary-03-90: #a72cff;
  --colors-tint-primary-02-10: #e6fcfd;
  --colors-tint-primary-02-20: #ccf9fb;
  --colors-tint-primary-02-30: #b3f5fa;
  --colors-tint-primary-02-40: #99f2f8;
  --colors-tint-primary-02-50: #80eff6;
  --colors-tint-primary-02-60: #66ecf4;
  --colors-tint-primary-02-70: #4de9f2;
  --colors-tint-primary-02-80: #33e5f1;
  --colors-tint-primary-02-90: #1ae2ef;
  --colors-tint-primary-01-10: #e6e8f7;
  --colors-tint-primary-01-20: #ccd2ef;
  --colors-tint-primary-01-30: #b3bbe7;
  --colors-tint-primary-01-40: #99a4df;
  --colors-tint-primary-01-50: #808ed8;
  --colors-tint-primary-01-60: #6677d0;
  --colors-tint-primary-01-70: #4d60c8;
  --colors-tint-primary-01-80: #3349c0;
  --colors-tint-primary-01-90: #1a33b8;
  --colors-tint-primary-01-110: #00168d;
  --colors-neutral-00: #000000;
  --colors-neutral-01: #2b2e31;
  --colors-neutral-02: #6b6d77;
  --colors-neutral-03: #a7a9b3;
  --colors-neutral-04: #c8cbd7;
  --colors-neutral-05: #d6d9e0;
  --colors-neutral-06: #eff0f4;
  --colors-neutral-07: #f7f7f9;
  --colors-neutral-08: #ffffff;
  --colors-static-neutral-00: #000000;
  --colors-static-neutral-01: #2b2e31;
  --colors-static-neutral-02: #6b6d77;
  --colors-static-neutral-03: #a7a9b3;
  --colors-static-neutral-04: #c8cbd7;
  --colors-static-neutral-05: #d6d9e0;
  --colors-static-neutral-06: #eff0f4;
  --colors-static-neutral-07: #f7f7f9;
  --colors-static-neutral-08: #ffffff;
  --colors-gradient-base-01: #0075cc;
  --colors-gradient-base-02: #b51db7;
  --colors-gradient-base-03: #9d15ff;
  --colors-gradient-base-04: #670bdf;
  --colors-alert-success: #008000;
  --colors-alert-error: #ce2a3e;
  --colors-alert-warning: #f6a623;
  --colors-alert-information: #6031a6;
  --colors-alert-null: #a7a9b3;
  --colors-elevation-opacity01: rgba(0, 0, 0, 0.08);
  --colors-elevation-opacity02: rgba(0, 0, 0, 0.16);
  --colors-gradient-01: #000000;
  --colors-gradient-02: #000000;
  --colors-gradient-03: #000000;
  --colors-gradient-04: #000000;
  --colors-gradient-05: #000000;
  --colors-gradient-06: #000000;
  --colors-mobile-01: #007aff;
  --colors-bridging-interactive-01: #001cb0;
  --colors-bridging-interactive-02: #00dfed;
  --colors-bridging-interactive-03: #6031a6;
  --colors-bridging-interactive-link-01: #001cb0;
  --colors-bridging-interactive-link-02: #3349c0;
  --colors-bridging-interactive-link-03: #6031a6;
  --colors-bridging-interactive-pressed-01: #00168d;
  --colors-bridging-interactive-pressed-02: #b3bbe7;
  --colors-bridging-interactive-pressed-03: #4d60c8;
  --colors-bridging-interactive-hover-01: #3349c0;
  --colors-bridging-interactive-hover-02: #ccd2ef;
  --colors-bridging-interactive-inverse-01: #ffffff;
  --colors-bridging-interactive-inverse-02: #00dfed;
  --colors-bridging-interactive-inverse-03: #6031a6;
  --colors-bridging-interactive-inverse-link-01: #ffffff;
  --colors-bridging-interactive-inverse-link-02: #ccd2ef;
  --colors-bridging-interactive-inverse-link-03: #b3bbe7;
  --colors-bridging-interactive-inverse-pressed-01: #b3bbe7;
  --colors-bridging-interactive-inverse-pressed-02: #4d60c8;
  --colors-bridging-interactive-inverse-hover-01: #ccd2ef;
  --colors-bridging-interactive-disabled-01: #c8cbd7;
  --colors-bridging-interactive-disabled-02: #6b6d77;
  --colors-bridging-interactive-disabled-03: #a7a9b3;
  --colors-bridging-interactive-focus-01: #fc9fe8;
  --colors-bridging-border-01: #2b2e31;
  --colors-bridging-border-02: #6b6d77;
  --colors-bridging-border-03: #d6d9e0;
  --colors-bridging-border-04: #001cb0;
  --colors-bridging-border-05: #ffffff;
  --colors-bridging-icon-01: #2b2e31;
  --colors-bridging-icon-02: #6b6d77;
  --colors-bridging-icon-03: #a7a9b3;
  --colors-bridging-icon-04: #001cb0;
  --colors-bridging-icon-05: #ffffff;
  --colors-bridging-icon-highlight-01: #001cb0;
  --colors-bridging-icon-highlight-02: #6031a6;
  --colors-bridging-icon-pressed-01: #ccd2ef;
  --colors-bridging-icon-pressed-02: #3349c0;
  --colors-bridging-icon-hover-01: #ffffff;
  --colors-bridging-icon-hover-02: #001cb0;
  --colors-bridging-icon-inverse-pressed-01: #3349c0;
  --colors-bridging-icon-inverse-pressed-02: #ccd2ef;
  --colors-bridging-icon-inverse-hover-01: #001cb0;
  --colors-bridging-focus-01: #fc9fe8;
  --colors-bridging-focus-02: #007aff;
  --colors-bridging-focus-03: #000000;
  --colors-bridging-type-01: #2b2e31;
  --colors-bridging-type-02: #6b6d77;
  --colors-bridging-type-03: #a7a9b3;
  --colors-bridging-type-04: #001cb0;
  --colors-bridging-type-05: #ffffff;
  --colors-bridging-type-highlight-01: #001cb0;
  --colors-bridging-type-highlight-02: #6031a6;
  --colors-bridging-type-pressed-01: #ccd2ef;
  --colors-bridging-type-pressed-02: #3349c0;
  --colors-bridging-type-hover-01: #ffffff;
  --colors-bridging-type-hover-02: #001cb0;
  --colors-bridging-type-inverse-pressed-01: #3349c0;
  --colors-bridging-type-inverse-pressed-02: #ccd2ef;
  --colors-bridging-type-inverse-hover-01: #001cb0;
  --colors-bridging-background-ui-01: #ffffff;
  --colors-bridging-background-ui-04: #2b2e31;
  --colors-bridging-background-level-01: #ffffff;
  --colors-bridging-background-level-02: #ffffff;
  --colors-bridging-background-level-03: #ffffff;
  --colors-bridging-background-level-04: #ffffff;
  --colors-bridging-background-level-05: #ffffff;
  --colors-bridging-background-level-gradient01: #000000;
  --colors-bridging-background-modal: #2b2e31;
  --colors-component-primary-01: #001cb0;
  --colors-component-primary-02: #00dfed;
  --colors-component-secondary-01: #ffe344;
  --colors-component-secondary-02: #f6a623;
  --colors-component-secondary-03: #9d15ff;
  --colors-component-secondary-04: #6031a6;
  --colors-component-tertiary-01: #38e255;
  --colors-component-tertiary-02: #00c981;
  --colors-component-tertiary-03: #f80ec5;
  --colors-component-tertiary-04: #ff5454;
  --colors-component-tint-primary-01-60: #6677d0;
  --colors-component-tint-primary-01-80: #3349c0;
  --colors-component-tint-primary-02-60: #66ecf4;
  --colors-component-tint-primary-02-80: #33e5f1;
  --colors-component-tint-secondary-01-60: #ffee8f;
  --colors-component-tint-secondary-01-80: #ffe969;
  --colors-component-tint-secondary-02-60: #faca7b;
  --colors-component-tint-secondary-02-80: #f8b84f;
  --colors-component-tint-secondary-03-60: #c473ff;
  --colors-component-tint-secondary-03-80: #b144ff;
  --colors-component-tint-secondary-04-60: #a083ca;
  --colors-component-tint-secondary-04-80: #805ab8;
  --colors-component-tint-tertiary-01-60: #94e8a2;
  --colors-component-tint-tertiary-01-80: #70e183;
  --colors-component-tint-tertiary-02-60: #80cc74;
  --colors-component-tint-tertiary-02-80: #56bb46;
  --colors-component-tint-tertiary-03-60: #fb6edc;
  --colors-component-tint-tertiary-03-80: #f93ed1;
  --colors-component-tint-tertiary-04-60: #fe8594;
  --colors-component-tint-tertiary-04-80: #fd5c70;
  --colors-component-button-default-background-primary-enabled: #001cb0;
  --colors-component-button-default-background-primary-hover: #3349c0;
  --colors-component-button-default-background-primary-pressed: #00168d;
  --colors-component-button-default-background-secondary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-default-background-secondary-hover: #ccd2ef;
  --colors-component-button-default-background-secondary-pressed: #b3bbe7;
  --colors-component-button-default-background-tertiary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-default-background-tertiary-hover: #ccd2ef;
  --colors-component-button-default-background-tertiary-pressed: #b3bbe7;
  --colors-component-button-default-background-disabled: #c8cbd7;
  --colors-component-button-default-type-primary-enabled: #ffffff;
  --colors-component-button-default-type-primary-hover: #ffffff;
  --colors-component-button-default-type-primary-pressed: #ccd2ef;
  --colors-component-button-default-type-secondary-enabled: #001cb0;
  --colors-component-button-default-type-secondary-hover: #001cb0;
  --colors-component-button-default-type-secondary-pressed: #3349c0;
  --colors-component-button-default-type-tertiary-enabled: #001cb0;
  --colors-component-button-default-type-tertiary-hover: #001cb0;
  --colors-component-button-default-type-tertiary-pressed: #3349c0;
  --colors-component-button-default-type-disabled: #6b6d77;
  --colors-component-button-default-icon-primary-enabled: #ffffff;
  --colors-component-button-default-icon-primary-hover: #ffffff;
  --colors-component-button-default-icon-primary-pressed: #ccd2ef;
  --colors-component-button-default-icon-secondary-enabled: #001cb0;
  --colors-component-button-default-icon-secondary-hover: #001cb0;
  --colors-component-button-default-icon-secondary-pressed: #3349c0;
  --colors-component-button-default-icon-tertiary-enabled: #001cb0;
  --colors-component-button-default-icon-tertiary-hover: #001cb0;
  --colors-component-button-default-icon-tertiary-pressed: #3349c0;
  --colors-component-button-default-icon-disabled: #6b6d77;
  --colors-component-button-default-border-secondary-enabled: #001cb0;
  --colors-component-button-inverse-background-primary-enabled: #ffffff;
  --colors-component-button-inverse-background-primary-hover: #ccd2ef;
  --colors-component-button-inverse-background-primary-pressed: #4d60c8;
  --colors-component-button-inverse-background-secondary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-inverse-background-secondary-hover: #ccd2ef;
  --colors-component-button-inverse-background-secondary-pressed: #4d60c8;
  --colors-component-button-inverse-background-tertiary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-inverse-background-tertiary-hover: #ccd2ef;
  --colors-component-button-inverse-background-tertiary-pressed: #4d60c8;
  --colors-component-button-inverse-background-disabled: #c8cbd7;
  --colors-component-button-inverse-type-primary-enabled: #001cb0;
  --colors-component-button-inverse-type-primary-hover: #001cb0;
  --colors-component-button-inverse-type-primary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-secondary-enabled: #ffffff;
  --colors-component-button-inverse-type-secondary-hover: #001cb0;
  --colors-component-button-inverse-type-secondary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-tertiary-enabled: #ffffff;
  --colors-component-button-inverse-type-tertiary-hover: #001cb0;
  --colors-component-button-inverse-type-tertiary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-disabled: #6b6d77;
  --colors-component-button-inverse-icon-primary-enabled: #001cb0;
  --colors-component-button-inverse-icon-primary-hover: #001cb0;
  --colors-component-button-inverse-icon-primary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-secondary-enabled: #ffffff;
  --colors-component-button-inverse-icon-secondary-hover: #001cb0;
  --colors-component-button-inverse-icon-secondary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-tertiary-enabled: #ffffff;
  --colors-component-button-inverse-icon-tertiary-hover: #001cb0;
  --colors-component-button-inverse-icon-tertiary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-disabled: #6b6d77;
  --colors-component-button-inverse-border-secondary-enabled: #ffffff;
  --colors-component-radio-border-enabled: #6b6d77;
  --colors-component-radio-border-hover: #2b2e31;
  --colors-component-radio-border-pressed: #00168d;
  --colors-component-radio-border-error: #ce2a3e;
  --colors-component-radio-border-selected-enabled: #001cb0;
  --colors-component-radio-border-selected-hover: #3349c0;
  --colors-component-radio-border-selected-error: #ce2a3e;
  --colors-component-radio-type-enabled: #2b2e31;
  --colors-component-radio-type-disabled: #6b6d77;
  --colors-component-radio-background: #ffffff;
  --colors-component-checkbox-border-enabled: #6b6d77;
  --colors-component-checkbox-border-hover: #2b2e31;
  --colors-component-checkbox-border-pressed: #00168d;
  --colors-component-checkbox-border-error: #ce2a3e;
  --colors-component-checkbox-background-unselected: #ffffff;
  --colors-component-checkbox-background-selected: #001cb0;
  --colors-component-checkbox-background-hover: #3349c0;
  --colors-component-checkbox-background-pressed: #00168d;
  --colors-component-checkbox-background-error: #ce2a3e;
  --colors-component-checkbox-icon: #ffffff;
  --colors-component-focus: #fc9fe8;
  --colors-component-text-input-background: #ffffff;
  --colors-component-text-input-border-enabled: #6b6d77;
  --colors-component-text-input-border-hover: #2b2e31;
  --colors-component-text-input-border-active: #001cb0;
  --colors-component-text-input-border-error: #ce2a3e;
  --colors-component-dropdown-background: #ffffff;
  --colors-component-dropdown-border-enabled: #6b6d77;
  --colors-component-dropdown-border-hover: #2b2e31;
  --colors-component-dropdown-border-active: #001cb0;
  --colors-component-dropdown-border-error: #ce2a3e;
  --colors-component-form-type-label: #2b2e31;
  --colors-component-form-type-hint: #6b6d77;
  --colors-component-form-type-input: #2b2e31;
  --colors-component-form-type-validation-error: #ce2a3e;
  --colors-component-form-type-validation-success: #2b2e31;
  --colors-component-form-type-validation-information: #2b2e31;
  --colors-component-form-icon-validation-error: #ce2a3e;
  --colors-component-form-icon-validation-success: #008000;
  --colors-component-form-icon-validation-information: #6031a6;
  --colors-component-form-modal-type-header: #2b2e31;
  --colors-component-form-modal-type-copy: #2b2e31;
  --colors-component-form-modal-background-enabled: #ffffff;
  --colors-component-link-default-enabled: #001cb0;
  --colors-component-link-default-hover: #3349c0;
  --colors-component-link-default-visited: #6031a6;
  --colors-component-link-inverse-enabled: #ffffff;
  --colors-component-link-inverse-hover: #ccd2ef;
  --colors-component-link-inverse-visited: #b3bbe7;
  --colors-component-card-interactive-border-enabled: #d6d9e0;
  --colors-component-card-interactive-border-hover: #d6d9e0;
  --colors-component-card-interactive-border-pressed: #00168d;
  --colors-component-card-interactive-border-selected: #001cb0;
  --colors-component-card-interactive-border-error: #ce2a3e;
  --colors-component-card-interactive-background-enabled: #ffffff;
  --colors-component-card-interactive-background-hover: #ffffff;
  --colors-component-card-interactive-background-pressed: #ffffff;
  --colors-component-card-interactive-background-selected: #ffffff;
  --colors-component-card-interactive-background-error: #ffffff;
  --colors-component-card-static-border: #d6d9e0;
  --colors-component-card-static-background-level0: #ffffff;
  --colors-component-card-static-background-level1: #ffffff;
  --colors-component-card-static-background-level5: #ffffff;
  --colors-component-card-type-header: #2b2e31;
  --colors-component-card-type-body: #2b2e31;
  --colors-component-notification-strip-background-promo: #6031a6;
  --colors-component-notification-strip-background-warning: #f6a623;
  --colors-component-notification-strip-background-information: #6031a6;
  --colors-component-notification-strip-background-error: #ce2a3e;
  --colors-component-notification-strip-background-success: #008000;
  --colors-component-notification-icon-warning: #f6a623;
  --colors-component-notification-icon-information: #6031a6;
  --colors-component-notification-icon-error: #ce2a3e;
  --colors-component-notification-icon-success: #008000;
  --colors-component-notification-icon-disabled: #a7a9b3;
  --colors-component-typography-enabled: #2b2e31;
  --colors-component-typography-muted: #6b6d77;
  --colors-component-typography-highlight: #001cb0;
  --colors-component-typography-error: #ce2a3e;
  --colors-component-typography-inverse-enabled: #ffffff;
  --colors-component-typography-secondary-highlight: #6031a6;
  --colors-component-scrim: #2b2e31;
  --colors-component-modal-static-dividing-line: #d6d9e0;
}

.colour-mode--dark,
dls-theme-agl[mode=dark] {
  --colors-primary-01: #001cb0;
  --colors-primary-02: #33e5f1;
  --colors-secondary-01: #ffe969;
  --colors-secondary-02: #f8b84f;
  --colors-secondary-03: #853cf5;
  --colors-secondary-04: #6031a6;
  --colors-tertiary-01: #82e493;
  --colors-tertiary-02: #56bb46;
  --colors-tertiary-03: #f80ec5;
  --colors-tertiary-04: #ff5454;
  --colors-tint-tertiary-03-10: #fee7f9;
  --colors-tint-tertiary-03-20: #fecff3;
  --colors-tint-tertiary-03-30: #fdb7ee;
  --colors-tint-tertiary-03-40: #fc9fe8;
  --colors-tint-tertiary-03-50: #fc87e2;
  --colors-tint-tertiary-03-60: #fb6edc;
  --colors-tint-tertiary-03-70: #fa56d6;
  --colors-tint-tertiary-03-80: #f93ed1;
  --colors-tint-tertiary-03-90: #f926cb;
  --colors-tint-tertiary-04-10: #ffebed;
  --colors-tint-tertiary-04-20: #ffd6db;
  --colors-tint-tertiary-04-30: #fec2c9;
  --colors-tint-tertiary-04-40: #feadb7;
  --colors-tint-tertiary-04-50: #fe99a6;
  --colors-tint-tertiary-04-60: #fe8594;
  --colors-tint-tertiary-04-70: #fe7082;
  --colors-tint-tertiary-04-80: #fd5c70;
  --colors-tint-tertiary-04-90: #fd475e;
  --colors-tint-tertiary-01-10: #edfbf0;
  --colors-tint-tertiary-01-20: #dbf7e0;
  --colors-tint-tertiary-01-30: #c9f4d1;
  --colors-tint-tertiary-01-40: #b7f0c1;
  --colors-tint-tertiary-01-50: #a6ecb2;
  --colors-tint-tertiary-01-60: #94e8a2;
  --colors-tint-tertiary-01-70: #82e493;
  --colors-tint-tertiary-01-80: #70e183;
  --colors-tint-tertiary-01-90: #5edd74;
  --colors-tint-tertiary-02-10: #eaf7e8;
  --colors-tint-tertiary-02-20: #d5eed1;
  --colors-tint-tertiary-02-30: #c0e6ba;
  --colors-tint-tertiary-02-40: #abdda3;
  --colors-tint-tertiary-02-50: #96d58c;
  --colors-tint-tertiary-02-60: #80cc74;
  --colors-tint-tertiary-02-70: #6bc45d;
  --colors-tint-tertiary-02-80: #56bb46;
  --colors-tint-tertiary-02-90: #41b32f;
  --colors-tint-secondary-02-10: #fef6e9;
  --colors-tint-secondary-02-20: #fdedd3;
  --colors-tint-secondary-02-30: #fce4bd;
  --colors-tint-secondary-02-40: #fbdba7;
  --colors-tint-secondary-02-50: #fbd391;
  --colors-tint-secondary-02-60: #faca7b;
  --colors-tint-secondary-02-70: #f9c165;
  --colors-tint-secondary-02-80: #f8b84f;
  --colors-tint-secondary-02-90: #f7af39;
  --colors-tint-secondary-04-10: #efeaf6;
  --colors-tint-secondary-04-20: #dfd6ed;
  --colors-tint-secondary-04-30: #cfc1e4;
  --colors-tint-secondary-04-40: #bfaddb;
  --colors-tint-secondary-04-50: #b098d3;
  --colors-tint-secondary-04-60: #a083ca;
  --colors-tint-secondary-04-70: #906fc1;
  --colors-tint-secondary-04-80: #805ab8;
  --colors-tint-secondary-04-90: #7046af;
  --colors-tint-secondary-01-10: #fffcec;
  --colors-tint-secondary-01-20: #fff9da;
  --colors-tint-secondary-01-30: #fff7c7;
  --colors-tint-secondary-01-40: #fff4b4;
  --colors-tint-secondary-01-50: #fff1a2;
  --colors-tint-secondary-01-60: #ffee8f;
  --colors-tint-secondary-01-70: #ffeb7c;
  --colors-tint-secondary-01-80: #ffe969;
  --colors-tint-secondary-01-90: #ffe657;
  --colors-tint-secondary-03-10: #f5e8ff;
  --colors-tint-secondary-03-20: #ebd0ff;
  --colors-tint-secondary-03-30: #e2b9ff;
  --colors-tint-secondary-03-40: #d8a1ff;
  --colors-tint-secondary-03-50: #ce8aff;
  --colors-tint-secondary-03-60: #c473ff;
  --colors-tint-secondary-03-70: #ba5bff;
  --colors-tint-secondary-03-80: #b144ff;
  --colors-tint-secondary-03-90: #a72cff;
  --colors-tint-primary-02-10: #e6fcfd;
  --colors-tint-primary-02-20: #ccf9fb;
  --colors-tint-primary-02-30: #b3f5fa;
  --colors-tint-primary-02-40: #99f2f8;
  --colors-tint-primary-02-50: #80eff6;
  --colors-tint-primary-02-60: #66ecf4;
  --colors-tint-primary-02-70: #4de9f2;
  --colors-tint-primary-02-80: #33e5f1;
  --colors-tint-primary-02-90: #1ae2ef;
  --colors-tint-primary-01-10: #e6e8f7;
  --colors-tint-primary-01-20: #ccd2ef;
  --colors-tint-primary-01-30: #b3bbe7;
  --colors-tint-primary-01-40: #99a4df;
  --colors-tint-primary-01-50: #808ed8;
  --colors-tint-primary-01-60: #6677d0;
  --colors-tint-primary-01-70: #4d60c8;
  --colors-tint-primary-01-80: #3349c0;
  --colors-tint-primary-01-90: #1a33b8;
  --colors-tint-primary-01-110: #00168d;
  --colors-neutral-00: #ffffff;
  --colors-neutral-01: #f7f7f9;
  --colors-neutral-02: #eff0f4;
  --colors-neutral-03: #d6d9e0;
  --colors-neutral-04: #c8cbd7;
  --colors-neutral-05: #a7a9b3;
  --colors-neutral-06: #6b6d77;
  --colors-neutral-07: #2b2e31;
  --colors-neutral-08: #000000;
  --colors-static-neutral-00: #000000;
  --colors-static-neutral-01: #2b2e31;
  --colors-static-neutral-02: #6b6d77;
  --colors-static-neutral-03: #a7a9b3;
  --colors-static-neutral-04: #c8cbd7;
  --colors-static-neutral-05: #d6d9e0;
  --colors-static-neutral-06: #eff0f4;
  --colors-static-neutral-07: #f7f7f9;
  --colors-static-neutral-08: #ffffff;
  --colors-gradient-base-01: #3391d6;
  --colors-gradient-base-02: #b51db7;
  --colors-gradient-base-03: #9d15ff;
  --colors-gradient-base-04: #670bdf;
  --colors-alert-success: #008000;
  --colors-alert-error: #ce2a3e;
  --colors-alert-warning: #f6a623;
  --colors-alert-information: #6031a6;
  --colors-alert-null: #a7a9b3;
  --colors-elevation-opacity01: rgba(0, 0, 0, 0.08);
  --colors-elevation-opacity02: rgba(0, 0, 0, 0.16);
  --colors-gradient-01: #000000;
  --colors-gradient-02: #000000;
  --colors-gradient-03: #000000;
  --colors-gradient-04: #000000;
  --colors-gradient-05: #000000;
  --colors-gradient-06: #000000;
  --colors-mobile-01: #0c84ff;
  --colors-bridging-interactive-01: #001cb0;
  --colors-bridging-interactive-02: #33e5f1;
  --colors-bridging-interactive-03: #6031a6;
  --colors-bridging-interactive-link-01: #001cb0;
  --colors-bridging-interactive-link-02: #3349c0;
  --colors-bridging-interactive-link-03: #6031a6;
  --colors-bridging-interactive-pressed-01: #00168d;
  --colors-bridging-interactive-pressed-02: #b3bbe7;
  --colors-bridging-interactive-pressed-03: #4d60c8;
  --colors-bridging-interactive-hover-01: #3349c0;
  --colors-bridging-interactive-hover-02: #ccd2ef;
  --colors-bridging-interactive-inverse-01: #ffffff;
  --colors-bridging-interactive-inverse-02: #33e5f1;
  --colors-bridging-interactive-inverse-03: #6031a6;
  --colors-bridging-interactive-inverse-link-01: #ffffff;
  --colors-bridging-interactive-inverse-link-02: #ccd2ef;
  --colors-bridging-interactive-inverse-link-03: #b3bbe7;
  --colors-bridging-interactive-inverse-pressed-01: #b3bbe7;
  --colors-bridging-interactive-inverse-pressed-02: #4d60c8;
  --colors-bridging-interactive-inverse-hover-01: #ccd2ef;
  --colors-bridging-interactive-disabled-01: #c8cbd7;
  --colors-bridging-interactive-disabled-02: #6b6d77;
  --colors-bridging-interactive-disabled-03: #a7a9b3;
  --colors-bridging-interactive-focus-01: #fc9fe8;
  --colors-bridging-border-01: #f7f7f9;
  --colors-bridging-border-02: #eff0f4;
  --colors-bridging-border-03: #a7a9b3;
  --colors-bridging-border-04: #001cb0;
  --colors-bridging-border-05: #ffffff;
  --colors-bridging-icon-01: #f7f7f9;
  --colors-bridging-icon-02: #eff0f4;
  --colors-bridging-icon-03: #d6d9e0;
  --colors-bridging-icon-04: #001cb0;
  --colors-bridging-icon-05: #ffffff;
  --colors-bridging-icon-highlight-01: #001cb0;
  --colors-bridging-icon-highlight-02: #6031a6;
  --colors-bridging-icon-pressed-01: #ccd2ef;
  --colors-bridging-icon-pressed-02: #3349c0;
  --colors-bridging-icon-hover-01: #ffffff;
  --colors-bridging-icon-hover-02: #001cb0;
  --colors-bridging-icon-inverse-pressed-01: #3349c0;
  --colors-bridging-icon-inverse-pressed-02: #ccd2ef;
  --colors-bridging-icon-inverse-hover-01: #001cb0;
  --colors-bridging-focus-01: #fc9fe8;
  --colors-bridging-focus-02: #0c84ff;
  --colors-bridging-focus-03: #000000;
  --colors-bridging-type-01: #f7f7f9;
  --colors-bridging-type-02: #eff0f4;
  --colors-bridging-type-03: #d6d9e0;
  --colors-bridging-type-04: #001cb0;
  --colors-bridging-type-05: #ffffff;
  --colors-bridging-type-highlight-01: #001cb0;
  --colors-bridging-type-highlight-02: #6031a6;
  --colors-bridging-type-pressed-01: #ccd2ef;
  --colors-bridging-type-pressed-02: #3349c0;
  --colors-bridging-type-hover-01: #ffffff;
  --colors-bridging-type-hover-02: #001cb0;
  --colors-bridging-type-inverse-pressed-01: #3349c0;
  --colors-bridging-type-inverse-pressed-02: #ccd2ef;
  --colors-bridging-type-inverse-hover-01: #001cb0;
  --colors-bridging-background-ui-01: #000000;
  --colors-bridging-background-ui-04: #f7f7f9;
  --colors-bridging-background-level-01: #000000;
  --colors-bridging-background-level-02: #000000;
  --colors-bridging-background-level-03: #000000;
  --colors-bridging-background-level-04: #000000;
  --colors-bridging-background-level-05: #000000;
  --colors-bridging-background-level-gradient01: #000000;
  --colors-bridging-background-modal: #f7f7f9;
  --colors-component-primary-01: #001cb0;
  --colors-component-primary-02: #33e5f1;
  --colors-component-secondary-01: #ffe969;
  --colors-component-secondary-02: #f8b84f;
  --colors-component-secondary-03: #853cf5;
  --colors-component-secondary-04: #6031a6;
  --colors-component-tertiary-01: #82e493;
  --colors-component-tertiary-02: #56bb46;
  --colors-component-tertiary-03: #f80ec5;
  --colors-component-tertiary-04: #ff5454;
  --colors-component-tint-primary-01-60: #6677d0;
  --colors-component-tint-primary-01-80: #3349c0;
  --colors-component-tint-primary-02-60: #66ecf4;
  --colors-component-tint-primary-02-80: #33e5f1;
  --colors-component-tint-secondary-01-60: #ffee8f;
  --colors-component-tint-secondary-01-80: #ffe969;
  --colors-component-tint-secondary-02-60: #faca7b;
  --colors-component-tint-secondary-02-80: #f8b84f;
  --colors-component-tint-secondary-03-60: #c473ff;
  --colors-component-tint-secondary-03-80: #b144ff;
  --colors-component-tint-secondary-04-60: #a083ca;
  --colors-component-tint-secondary-04-80: #805ab8;
  --colors-component-tint-tertiary-01-60: #94e8a2;
  --colors-component-tint-tertiary-01-80: #70e183;
  --colors-component-tint-tertiary-02-60: #80cc74;
  --colors-component-tint-tertiary-02-80: #56bb46;
  --colors-component-tint-tertiary-03-60: #fb6edc;
  --colors-component-tint-tertiary-03-80: #f93ed1;
  --colors-component-tint-tertiary-04-60: #fe8594;
  --colors-component-tint-tertiary-04-80: #fd5c70;
  --colors-component-button-default-background-primary-enabled: #001cb0;
  --colors-component-button-default-background-primary-hover: #3349c0;
  --colors-component-button-default-background-primary-pressed: #00168d;
  --colors-component-button-default-background-secondary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-default-background-secondary-hover: #ccd2ef;
  --colors-component-button-default-background-secondary-pressed: #b3bbe7;
  --colors-component-button-default-background-tertiary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-default-background-tertiary-hover: #ccd2ef;
  --colors-component-button-default-background-tertiary-pressed: #b3bbe7;
  --colors-component-button-default-background-disabled: #c8cbd7;
  --colors-component-button-default-type-primary-enabled: #ffffff;
  --colors-component-button-default-type-primary-hover: #ffffff;
  --colors-component-button-default-type-primary-pressed: #ccd2ef;
  --colors-component-button-default-type-secondary-enabled: #001cb0;
  --colors-component-button-default-type-secondary-hover: #001cb0;
  --colors-component-button-default-type-secondary-pressed: #3349c0;
  --colors-component-button-default-type-tertiary-enabled: #001cb0;
  --colors-component-button-default-type-tertiary-hover: #001cb0;
  --colors-component-button-default-type-tertiary-pressed: #3349c0;
  --colors-component-button-default-type-disabled: #eff0f4;
  --colors-component-button-default-icon-primary-enabled: #ffffff;
  --colors-component-button-default-icon-primary-hover: #ffffff;
  --colors-component-button-default-icon-primary-pressed: #ccd2ef;
  --colors-component-button-default-icon-secondary-enabled: #001cb0;
  --colors-component-button-default-icon-secondary-hover: #001cb0;
  --colors-component-button-default-icon-secondary-pressed: #3349c0;
  --colors-component-button-default-icon-tertiary-enabled: #001cb0;
  --colors-component-button-default-icon-tertiary-hover: #001cb0;
  --colors-component-button-default-icon-tertiary-pressed: #3349c0;
  --colors-component-button-default-icon-disabled: #eff0f4;
  --colors-component-button-default-border-secondary-enabled: #001cb0;
  --colors-component-button-inverse-background-primary-enabled: #ffffff;
  --colors-component-button-inverse-background-primary-hover: #ccd2ef;
  --colors-component-button-inverse-background-primary-pressed: #4d60c8;
  --colors-component-button-inverse-background-secondary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-inverse-background-secondary-hover: #ccd2ef;
  --colors-component-button-inverse-background-secondary-pressed: #4d60c8;
  --colors-component-button-inverse-background-tertiary-enabled: rgba(0, 0, 0, 0);
  --colors-component-button-inverse-background-tertiary-hover: #ccd2ef;
  --colors-component-button-inverse-background-tertiary-pressed: #4d60c8;
  --colors-component-button-inverse-background-disabled: #c8cbd7;
  --colors-component-button-inverse-type-primary-enabled: #001cb0;
  --colors-component-button-inverse-type-primary-hover: #001cb0;
  --colors-component-button-inverse-type-primary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-secondary-enabled: #ffffff;
  --colors-component-button-inverse-type-secondary-hover: #001cb0;
  --colors-component-button-inverse-type-secondary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-tertiary-enabled: #ffffff;
  --colors-component-button-inverse-type-tertiary-hover: #001cb0;
  --colors-component-button-inverse-type-tertiary-pressed: #ccd2ef;
  --colors-component-button-inverse-type-disabled: #eff0f4;
  --colors-component-button-inverse-icon-primary-enabled: #001cb0;
  --colors-component-button-inverse-icon-primary-hover: #001cb0;
  --colors-component-button-inverse-icon-primary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-secondary-enabled: #ffffff;
  --colors-component-button-inverse-icon-secondary-hover: #001cb0;
  --colors-component-button-inverse-icon-secondary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-tertiary-enabled: #ffffff;
  --colors-component-button-inverse-icon-tertiary-hover: #001cb0;
  --colors-component-button-inverse-icon-tertiary-pressed: #ccd2ef;
  --colors-component-button-inverse-icon-disabled: #eff0f4;
  --colors-component-button-inverse-border-secondary-enabled: #ffffff;
  --colors-component-radio-border-enabled: #eff0f4;
  --colors-component-radio-border-hover: #f7f7f9;
  --colors-component-radio-border-pressed: #00168d;
  --colors-component-radio-border-error: #ce2a3e;
  --colors-component-radio-border-selected-enabled: #001cb0;
  --colors-component-radio-border-selected-hover: #3349c0;
  --colors-component-radio-border-selected-error: #ce2a3e;
  --colors-component-radio-type-enabled: #f7f7f9;
  --colors-component-radio-type-disabled: #eff0f4;
  --colors-component-radio-background: #000000;
  --colors-component-checkbox-border-enabled: #eff0f4;
  --colors-component-checkbox-border-hover: #f7f7f9;
  --colors-component-checkbox-border-pressed: #00168d;
  --colors-component-checkbox-border-error: #ce2a3e;
  --colors-component-checkbox-background-unselected: #000000;
  --colors-component-checkbox-background-selected: #001cb0;
  --colors-component-checkbox-background-hover: #3349c0;
  --colors-component-checkbox-background-pressed: #00168d;
  --colors-component-checkbox-background-error: #ce2a3e;
  --colors-component-checkbox-icon: #ffffff;
  --colors-component-focus: #fc9fe8;
  --colors-component-text-input-background: #000000;
  --colors-component-text-input-border-enabled: #eff0f4;
  --colors-component-text-input-border-hover: #f7f7f9;
  --colors-component-text-input-border-active: #001cb0;
  --colors-component-text-input-border-error: #ce2a3e;
  --colors-component-dropdown-background: #000000;
  --colors-component-dropdown-border-enabled: #eff0f4;
  --colors-component-dropdown-border-hover: #f7f7f9;
  --colors-component-dropdown-border-active: #001cb0;
  --colors-component-dropdown-border-error: #ce2a3e;
  --colors-component-form-type-label: #f7f7f9;
  --colors-component-form-type-hint: #eff0f4;
  --colors-component-form-type-input: #f7f7f9;
  --colors-component-form-type-validation-error: #ce2a3e;
  --colors-component-form-type-validation-success: #f7f7f9;
  --colors-component-form-type-validation-information: #f7f7f9;
  --colors-component-form-icon-validation-error: #ce2a3e;
  --colors-component-form-icon-validation-success: #008000;
  --colors-component-form-icon-validation-information: #6031a6;
  --colors-component-form-modal-type-header: #f7f7f9;
  --colors-component-form-modal-type-copy: #f7f7f9;
  --colors-component-form-modal-background-enabled: #000000;
  --colors-component-link-default-enabled: #001cb0;
  --colors-component-link-default-hover: #3349c0;
  --colors-component-link-default-visited: #6031a6;
  --colors-component-link-inverse-enabled: #ffffff;
  --colors-component-link-inverse-hover: #ccd2ef;
  --colors-component-link-inverse-visited: #b3bbe7;
  --colors-component-card-interactive-border-enabled: #a7a9b3;
  --colors-component-card-interactive-border-hover: #a7a9b3;
  --colors-component-card-interactive-border-pressed: #00168d;
  --colors-component-card-interactive-border-selected: #001cb0;
  --colors-component-card-interactive-border-error: #ce2a3e;
  --colors-component-card-interactive-background-enabled: #000000;
  --colors-component-card-interactive-background-hover: #000000;
  --colors-component-card-interactive-background-pressed: #000000;
  --colors-component-card-interactive-background-selected: #000000;
  --colors-component-card-interactive-background-error: #000000;
  --colors-component-card-static-border: #a7a9b3;
  --colors-component-card-static-background-level0: #000000;
  --colors-component-card-static-background-level1: #000000;
  --colors-component-card-static-background-level5: #000000;
  --colors-component-card-type-header: #f7f7f9;
  --colors-component-card-type-body: #f7f7f9;
  --colors-component-notification-strip-background-promo: #6031a6;
  --colors-component-notification-strip-background-warning: #f6a623;
  --colors-component-notification-strip-background-information: #6031a6;
  --colors-component-notification-strip-background-error: #ce2a3e;
  --colors-component-notification-strip-background-success: #008000;
  --colors-component-notification-icon-warning: #f6a623;
  --colors-component-notification-icon-information: #6031a6;
  --colors-component-notification-icon-error: #ce2a3e;
  --colors-component-notification-icon-success: #008000;
  --colors-component-notification-icon-disabled: #a7a9b3;
  --colors-component-typography-enabled: #f7f7f9;
  --colors-component-typography-muted: #eff0f4;
  --colors-component-typography-highlight: #001cb0;
  --colors-component-typography-error: #ce2a3e;
  --colors-component-typography-inverse-enabled: #ffffff;
  --colors-component-typography-secondary-highlight: #6031a6;
  --colors-component-scrim: #f7f7f9;
  --colors-component-modal-static-dividing-line: #a7a9b3;
}